export default {
    path: '/order_actions',
    name: 'order_actions',
    component: () => import('../components/orderaction/Layout'),
    redirect: { name: 'OrderActionList' },
    meta: {
        breadcrumb: 'orderaction.orderactions',
    },
    children: [
        {
            name: 'OrderActionList',
            path: '',
            component: () => import('../views/orderaction/List'),
            meta: {
                breadcrumb: 'global.list',
            },
        },
        {
            name: 'OrderActionCreate',
            path: 'new',
            component: () => import('../views/orderaction/Create'),
            meta: {
                breadcrumb: 'global.add',
            },
        },
        {
            name: 'OrderActionUpdate',
            path: ':id/edit',
            component: () => import('../views/orderaction/Update'),
            meta: {
                breadcrumb: 'orderaction.orderaction',
            },
        },
        {
            name: 'OrderActionShow',
            path: ':id',
            component: () => import('../views/orderaction/Show'),
            meta: {
                breadcrumb: 'orderaction.orderaction',
            },
        }
    ]
};
